import {useState} from 'react'
import {useDrawer, useGlobalConfigState} from '_context'
import {useAnalytics, useOpenDrawer} from '_customHooks'

const useMinicart = () => {
    const {openMinicartDrawer} = useOpenDrawer()
    const {analyticsEventMinicartLayer, analyticsEventCloseLayer} = useAnalytics()
    const {closeDrawer} = useDrawer()
    const [isMinicartOpen, setIsMinicartOpen] = useState(false)

    const {appPreferences} = useGlobalConfigState()
    const {
        // PayPal Express
        PAYPAL_EXPRESS_Disable_Funds,
        PAYPAL_EXPRESS_Allowed_Currencies,
        PP_API_PaymentAction,
        PP_API_Button_Location,
        paypal_clientId,
        paypal_button_style,
        ShippingMethod_NI,
        // Apple Pay
        Allowed_Suretax_Dispatch,
        ApplePay_Enabled,
        ApplePay_MerchantId,
        ApplePay_MerchantName,
        ApplePay_MerchantCapabilities,
        ApplePay_SupportedNetworks,
        hostLink,
    } = appPreferences

    const globalPrefs = {
        PAYPAL_EXPRESS_Disable_Funds,
        PAYPAL_EXPRESS_Allowed_Currencies,
        PP_API_PaymentAction,
        PP_API_Button_Location,
        paypal_clientId,
        paypal_button_style,
        ShippingMethod_NI,
        Allowed_Suretax_Dispatch,
        ApplePay_Enabled,
        ApplePay_MerchantId,
        ApplePay_MerchantName,
        ApplePay_MerchantCapabilities,
        ApplePay_SupportedNetworks,
        hostLink,
    }

    const onMinicartClose = () => {
        analyticsEventCloseLayer()
        setIsMinicartOpen(false)
    }

    const openMinicart = (hasHiddenPrices?: boolean) => {
        analyticsEventMinicartLayer()
        openMinicartDrawer({
            hasHiddenPrices: hasHiddenPrices,
            minicartPreferences: globalPrefs,
            onClose: () => onMinicartClose(),
        })

        setIsMinicartOpen(true)
    }

    const closeMinicart = () => {
        closeDrawer()
    }

    const previewMinicart = (hasHiddenPrices?: boolean) => {
        analyticsEventMinicartLayer()
        openMinicartDrawer({
            hasHiddenPrices: hasHiddenPrices,
            minicartPreferences: globalPrefs,
            onClose: () => onMinicartClose(),
            autoClosingTimeout: 5 * 1000,
        })

        setIsMinicartOpen(true)
    }
    return {
        openMinicart,
        closeMinicart,
        isMinicartOpen,
        previewMinicart,
    }
}

export {useMinicart}
